import { gql, useQuery } from '@apollo/client'
import { MyContributableBrandsQuery, MyContributableBrandsQueryVariables } from 'types/graphql'
import { brandRowFieldsFragment } from 'modules/brands/list/queries/getDiscoveryBrands'

const getMyBrands = gql`
  ${brandRowFieldsFragment}

  query MyContributableBrands {
    myContributableBrands {
      ...BrandRowFields
    }
  }
`

export const useMyBrands = () => {
  return useQuery<MyContributableBrandsQuery, MyContributableBrandsQueryVariables>(getMyBrands)
}
